export class Mapa {
  rua: string;
  numero: number;
  bairro: string;
  cidade: string;
  estado: string;
}


